<template>
  <v-container class="pa-1" fluid>
    <v-card :disabled="loading" :loading="loading" color="grey-darken-3" elevation="1" class="temp-card fill-height pa-0">
      <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
      </v-overlay>

      <div class="text-start">
        <div class="d-flex align-items-baseline">
          <div class="text-caption ml-2 mt-2">{{ tempSensorData["name"] }}</div>
          <div class="d-flex ml-auto align-items-end mr-1">
            <span class="thermo-icon mdi mdi-thermometer"></span>
          </div>
        </div>
        <div class="d-flex">
          <div class="d-flex align-items-baseline">
            <div class="text-h5 mt-2 ml-2" :style="{ color: tempColor }">{{ tempSensorData["temp"] }}</div>
            <div class="text-body-1 mt-2 ml-1">°C</div>
          </div>
          <div class="d-flex flex-column align-items-start mt-2 ml-1">
            <div class="text-smallest mdi mdi-arrow-up-thin">{{ max }}</div>
            <div class="text-smallest mdi mdi-arrow-down-thin">{{ min }}</div>
          </div>
        </div>
      </div>

      <div class="graphTemp">
        <canvas height="100" ref="chartCanvas"></canvas>
      </div>
    </v-card>
  </v-container>
</template>
<script>
import { Chart } from "chart.js/auto"; // Import automaticky detekuje potřebné moduly

export default {
  props: {
    chartData: {},
    tempSensorData: {},
  },
  data() {
    return {
      loading: true, // Stav načítání
      max: 0,
      min: 0,
    };
  },
  mounted() {
    this.renderChart();
  },
  watch: {
    // Přerenderování grafu, pokud se data nebo možnosti změní
    tempSensorData: {
      handler() {
        if (this.tempSensorData["status"] == "loading") {
          this.loading = true;
        } else {
          this.loading = false;
        }
      },
      deep: true,
    },
    chartData: {
      handler() {
        this.getmaxmin();
        this.renderChart();
      },
      deep: true,
    },
    chartOptions: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },
  computed: {
    tempColor() {
      return this.tempSensorData["temp"] < 0 ? "#42A5F5" : "white";
    },
  },
  methods: {
    getmaxmin() {
      this.max = Math.max(...this.chartData.map((item) => item.y));
      this.min = Math.min(...this.chartData.map((item) => item.y));
    },
    renderChart() {
      if (this.chart) {
        this.chart.destroy(); // Zničí starý graf před vytvořením nového
      }
      this.chart = new Chart(this.$refs.chartCanvas, {
        type: "line", // Typ grafu
        data: {
          datasets: [
            {
              label: "temp",
              data: this.chartData,
              borderColor: "#64DD17",
              borderWidth: 2,
              pointRadius: 0,
              backgroundColor: "rgba(2, 192, 192, 0.1)", // Barva vyplněné plochy (poloprůhledná)
              tension: 0.2,
              fill: true, // Nastaví vyplnění plochy pod čárou
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            title: { display: false },
            legend: { display: false },
            tooltip: { enabled: false },
          },
          interaction: {
            intersect: false,
          },
          scales: {
            x: { title: { display: false, text: "Čas" }, ticks: { display: false }, grid: { display: false }, border: { display: false } },
            y: { title: { display: false, text: "Teplota (°C)" }, ticks: { display: false }, grid: { display: false }, beginAtZero: true, border: { display: false }, min: this.min - 2, max: this.max + 2 },
          },
        },
      });
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy(); // Čištění při zničení komponenty
    }
  },
};
</script>

<style scoped>
.temp-card {
  min-width: 106px; /* Minimální šířka karty */
  max-width: 500px; /* Maximální šířka karty */
  min-height: 100px; /* Minimální výška karty */
  max-height: 150px; /* Maximální výška karty */
}

.thermo-icon {
  color: #a7a7a7;
}
.text-smallest {
  font-size: 10px;
  color: #a7a7a7;
}
.graphTemp {
  margin-left: -10px;
  margin-bottom: -12px;
}
</style>
